import { JSX } from 'react'
import { Box, HStack, Separator } from '@chakra-ui/react'


// eslint-disable-next-line @typescript-eslint/naming-convention
import Billboard from './components/billboard.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Marshal from './components/marshal.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Statistic from './components/statistic.tsx'




export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	return (
		<Box
			p="4"
			h="full"
			display="flex"
			gap="4"
			flexDirection="column"
		>
			<Billboard _id={props._id} />

			<Separator />

			<HStack minH="0" flex="auto" gap="0" alignItems="flex-start">
				<Marshal _id={props._id} />

				<Separator h="full" mr="4" orientation="vertical" />

				<Statistic _id={props._id} />

			</HStack>


		</Box>


	)

}
